import IspLoginCheckModel from "@core/model/isp_login";
import IspLoginJobModel from "@core/model/isp_login_job";

export {};

let codeParam: string = '';
let retriesCount: number = 0;

document.addEventListener('started-guest', () => {
    const qs = document.location.search ? document.location.search : '?provider=';
    document.location.href = config.routes.login + qs;
});

document.addEventListener('started-user', () => {
    // Get provider and code from query params and prefill form if they exist
    const params = new URLSearchParams(window.location.search);
    // Emailed links may capitalize the provider ('?provider=Telemach'), but
    // option values and data-provider attributes are lowercase.
    const provider = (params.get('provider') || '').toLowerCase();
    const code = params.get('code');
    const providerSelect = app.html.q('#provider-select') as HTMLSelectElement | null;

    if (code) {
        codeParam = code;
    }

    if (providerSelect) {
        providerSelect.value = provider;
        providerSelect.dispatchEvent(new Event('change'));
    }
});

function toggleProviderTab(event: Event): void {
    if (!window.app) {
        return;
    }

    const selectInput = event.currentTarget as HTMLInputElement;
    const selectedProvider = selectInput.value;

    const activeForm = app.html.q('.provider_tab--active form') as HTMLFormElement | null;
    if (activeForm) {
        activeForm.reset();
    }

    app.html.removeClass('.provider_tab--active', 'provider_tab--active');
    app.html.addClass(`.provider_tab[data-provider="${selectedProvider}"]`, 'provider_tab--active');

    if (codeParam) {
        const codeInput = app.html.q('.provider_tab--active input[name="username"]') as HTMLInputElement | null;
        if (codeInput) {
            codeInput.value = codeParam;
        }
    }

    app.html.hide('.callout');
}

function ispLogin(event: Event): void {
    event.preventDefault();

    if (!window.app) {
        return;
    }

    const form = event.target as HTMLFormElement;
    retriesCount = 0;

    // The whole ispLogin -> ispLoginCheck keeps the button disabled/spinning
    // for the entire flow and only clears it once it truly settles (success, error, or timeout).
    app.voyoForms.submit(form,
        async (data) => {
            const {username, password, provider} = data;

            // Telemach, Yettel, SBB do not use password
            if (!username || !provider) {
                return;
            }

            const ispJob = await app.gql.ispLogin(username, password || '', provider);
            await checkIspLoginJob(ispJob, form);
        }
    );
}

async function checkIspLoginJob(ispJob: IspLoginJobModel, form: HTMLFormElement): Promise<void> {
    if (!ispJob.jobHash) {
        throw {
            code: '',
            message: '{{T "activation.provider.activationFailed" }}'
        };
    }

    const checkData = await app.gql.ispLoginCheck(ispJob.jobHash);
    await handleIspLoginCheckResponse(checkData, ispJob, form);
}

async function handleIspLoginCheckResponse(checkData: IspLoginCheckModel, ispJob: IspLoginJobModel, form: HTMLFormElement): Promise<void> {
    retriesCount++;

    if (checkData.status === 'created') {
        await handleCreatedStatus(ispJob, form);
        return;
    }

    const user = checkData.payload;
    if (!user) {
        throw {
            code: '',
            message: '{{T "activation.provider.activationFailed" }}'
        };
    }

    app.user.userLoaded(user);

    if (app.user.user?.isSubscribed) {
        document.location.href = config.routes.activation_success;
    }
}

async function handleCreatedStatus(ispJob: IspLoginJobModel, form: HTMLFormElement): Promise<void> {
    if (retriesCount > ispJob.maxRetries) {
        throw {
            code: '',
            message: '{{T "activation.provider.timeout" }}'
        };
    }

    await delay(ispJob.retryDelay * 1000);
    await checkIspLoginJob(ispJob, form);
}

function delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
}

window.toggleProviderTab = toggleProviderTab;
window.ispLogin = ispLogin;
